<template>
  <div
    ref="wrapper"
    class="wrapper"
  >
    <img
      class="img-map"
      :src="src"
      alt=""
    >
    <toolTip
      v-for="(item, index) in list"
      :key="index"
      :info="item"
      :scale-x="scaleX"
      :scale-y="scaleY"
      :main-color="mainColor"
      :background-color="backgroundColor"
      :text-style="textStyle"
    />
  </div>
</template>

<script>
import debounce from '@/option/common/util.js'
import toolTip from './tooltip.vue'
export default {
  name: 'ImgMap',
  components: {
    toolTip
  },
  props: {
    src: {
      type: String,
      default: ''
    },
    mainColor: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    textStyle: {
      type: Object,
      default: () => ({
        fontColor: '#1E90FF',
        fontSize: 12
      })
    },
    list: {
      type: Array,
      default() {
        return [{
          x: 600,
          y: 200,
          name: '锚点',
          list: [{
            name: '属性1',
            val: 12341232
          }, {
            name: '属性2',
            val: 12341232
          }, {
            name: '属性1',
            val: 12341232
          }]
        }]
      }
    }
  },
  data() {
    return {
      scaleX: 1,
      scaleY: 1,
      observer: null
    }
  },
  computed: {
    style() {
      return {
        background: `url(${this.src}) no-repeat`
      }
    }
  },
  beforeUnmount() {
    // this.destroyListener()
  },
  mounted() {
    this.initListener()
  },
  methods: {
    observeWidth() {
      this.$nextTick(() => {
        this.observer = new ResizeObserver(entries => {
          this.$_resizeHandler()
        })
        this.observer.observe(this.$refs.wrapper)
      })
    },
    resize() {
      const width = this.$refs.wrapper.getBoundingClientRect().width
      const height = this.$refs.wrapper.getBoundingClientRect().height
      this.scaleX = width / 1840
      this.scaleY = height / 905
    },
    initListener() {
      this.resize()
      this.$_resizeHandler = debounce(() => {
        this.resize()
      }, 200)
      this.observeWidth()
    },
    destroyListener() {
      this.$_resizeHandler = null
      this.observer.unobserve(this.$refs.wrapper)
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
    width: 100%;
    height: 100%;
}
.img-map {
    width: 100%;
    height: 100%;
}
</style>
